import React, { useState } from 'react';
import Bar from '../charts/Bar';
import DelayRender from '../DelayRender';
import useMetronome from '../utility/useMetronome';
import HamQuest from '../api/HamQuestGiver';
import { QuestRoute } from '../api/QuestRoutes';
import { formatCurrency } from '../utility/functions';

const Sales = ({ ...props }) => {
    const [data, setData] = useState([]);
    const [fetchData, setFetchData] = useState(5);

    useMetronome(() => {
        if (fetchData > 0) {
            setFetchData(fetchData - 1)
            HamQuest.get(QuestRoute.dashboard.sales)
                .then(res => setData(res))
                .catch(ex => console.error(ex))
        }
    }, 60000)

    const chartProps = {
        horizontal: true,
        xAxisLabel: 'Item Sales',
        xAxis: data.map(e => e.location),
        data: [{
            name: 'Sales',
            data: data.map(e => e.items.reduce((acc, cur) => acc + cur.totalSales, 0)),
        }],
        stacked: true,
        tooltipFormatter: (e) => formatCurrency(e),
        xAxisFormatter: (e) => formatCurrency(e)
    }

    return (
        <DelayRender>
            <Bar chartProps={chartProps} />
        </DelayRender>
    );
}

export default Sales;